export const GET_CLIENT_LIST = "GET_CLIENT_LIST";
export const CLIENT_PROCESSING = "CLIENT_PROCESSING";
export const STOP_CLIENT_PROCESSING = "STOP_CLIENT_PROCESSING";
